import { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { statusesActions } from 'actions/modules/statuses';

import Body from './Body';
import Header from './Header';

const History = () => {
  const dispatch = useDispatch()

  useEffect(() => () => {
    dispatch(statusesActions.changeValue(undefined, "name"))
  }, [dispatch])
  return (
    <div className="statuses__content statuses__history">
      <Header/>
      <Body/>
    </div>
  )
}

export default memo(History);